import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import * as React from 'react';
import {useNavigate} from 'react-router-dom';

export default function CommonAppbar({isMainPage, pageHeader}) {
  const navigate = useNavigate();
  return <>
    <AppBar position="static" sx={{mb: 3}}>
      <Toolbar>
        {!isMainPage && <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{mr: 0}}
        >
          <ArrowBackIcon onClick={() => navigate(-1)}/>
        </IconButton>
        }

        <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
          {pageHeader}
        </Typography>
      </Toolbar>
    </AppBar>
  </>
}
